import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectAllHostsCountWs, selectReadOnly, selectTotalHostsCount } from 'store/Faraday/selectors';
import AddButton from 'Common/Components/Contextualization/AddButton';
import { openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE, MODAL_CREATE_SERVICE } from 'store/modals/modals';
import { selectEmptyActiveWorkspaces } from 'store/Workspace/selectors';

const CreateActions = ({ entity }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const addText = intl.formatMessage({ id: 'service.addService' });
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = !readOnly;
  const assetsCount = useSelector(selectAllHostsCountWs);
  const noAssets = assetsCount === 0;
  const assetsCountAllWorkspaces = useSelector(selectTotalHostsCount);
  const noAssetsFromAllWorkspaces = assetsCountAllWorkspaces === 0;
  const noWorkspaces = useSelector(selectEmptyActiveWorkspaces);

  const handleShow = () => {
    if ((entity === 'servicesGeneral') && (noAssetsFromAllWorkspaces || noWorkspaces)) dispatch(openModal(MODAL_CANT_CREATE));
    else if ((entity === 'services') && noAssets) dispatch(openModal(MODAL_CANT_CREATE));
    else if (canUpdate) dispatch(openModal(MODAL_CREATE_SERVICE));
  };

  return (
    <AddButton
      onClick={ handleShow }
      title={ addText }
      text={ addText }
      disabled={ readOnly }
    />
  );
};

export default CreateActions;
